// code for excute api
module.exports = {


    handleData: {
        REQUIRED_ONLY: 'requiredOnly',
        STRING : 'string',
        INT : 'int',
        SMALLINT : 'smallint',
        TINYINT : 'tinyint',
        FLOAT : 'float',
        DATE : 'datetime',
        BOOLEAN : 'Boolean',
    },


    LIMIT_FILE_SIZE: 1048576*10, //1048576 = 1MB
    LIMIT_IMAGE_SIZE: 1048576*10,//1048576 = 1MB
    IMPORT_SAMPLE_FILE_PATH: 'file/FileExcelMau/'

}